import { useTranslation } from 'react-i18next'

import {
  isInfoEmailAccount,
  isServiceEmailAccount,
} from '../../../../utils/email'

import {
  ACCOUNT_ICONS,
  ACCOUNT_TYPE_TOOLTIP_KEY,
  PRIVATE_ACCOUNT,
  PUBLIC_ACCOUNT,
  SYSTEM_ACCOUNT,
} from './useEmailListItemTypeIcon.constants'

export function useEmailListItemTypeIcon({ isPublicOption, value }) {
  const { t } = useTranslation()

  function getAccountType() {
    switch (true) {
      case isInfoEmailAccount(value):
      case isServiceEmailAccount(value):
        return SYSTEM_ACCOUNT
      case isPublicOption(value):
        return PUBLIC_ACCOUNT
      default:
        return PRIVATE_ACCOUNT
    }
  }

  const accountType = getAccountType()

  return {
    Icon: ACCOUNT_ICONS[accountType],
    tooltip: t(ACCOUNT_TYPE_TOOLTIP_KEY[accountType]),
  }
}
